(() => {
  const patch = (CartDrawer) => {
    if (!CartDrawer || CartDrawer.prototype.__mellowbyCartModes20260510) return;
    CartDrawer.prototype.__mellowbyCartModes20260510 = true;

    const originalOpen = CartDrawer.prototype.open;
    const originalRenderContents = CartDrawer.prototype.renderContents;

    const getCount = (drawer) => {
      const countBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"], #cart-icon-bubble .cart-count-bubble span');
      const fromBubble = parseInt((countBubble && countBubble.textContent || '').trim(), 10);
      if (Number.isFinite(fromBubble) && fromBubble > 0) return fromBubble;
      return drawer.querySelectorAll('.cart-item').length || 0;
    };

    const setBagHeading = (drawer) => {
      const heading = drawer.querySelector('#CartDrawer .drawer__heading, .drawer__heading');
      const count = getCount(drawer);
      if (!heading) return;
      heading.innerHTML = count > 0
        ? `Shopping Bag <span class="cart-drawer__count">(${count})</span>`
        : 'Shopping Bag';
    };

    const setAddedHeading = (drawer) => {
      const heading = drawer.querySelector('#CartDrawer .drawer__heading, .drawer__heading');
      const count = getCount(drawer);
      if (heading) heading.textContent = count === 1 ? '1 Item Added To Bag' : `${count} Items Added To Bag`;
    };

    const buildRecommendationHtml = (html, cartIds) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const wrap = doc.querySelector('.cart-drawer__recs');
      if (!wrap) return null;

      let kept = 0;
      Array.from(wrap.querySelectorAll('.cart-drawer__rec-card')).forEach((card) => {
        const productId = parseInt(card.getAttribute('data-product-id') || '0', 10);
        if (cartIds.indexOf(productId) === -1 && kept < 8) {
          card.removeAttribute('hidden');
          kept += 1;
        } else {
          card.remove();
        }
      });

      if (!kept) return null;
      wrap.classList.add('cart-drawer__recs--carousel');
      const title = wrap.querySelector('.cart-drawer__recs-title');
      if (title) title.textContent = 'Frequently Bought Together';
      return wrap.outerHTML;
    };

    const markRecommendationsReady = (drawer) => {
      drawer.classList.remove('mel-recs-loading');
      drawer.classList.add('mel-recs-ready');
    };

    const refreshRecommendationCarousel = async (drawer) => {
      if (drawer.dataset.melRecsFinal === '1') return;

      const slot = drawer.querySelector('[data-cart-recs]');
      if (!slot) {
        const existing = drawer.querySelector('.cart-drawer__recs');
        if (existing) {
          existing.classList.add('cart-drawer__recs--carousel');
          existing.querySelectorAll('.cart-drawer__rec-card').forEach((card) => card.removeAttribute('hidden'));
          const title = existing.querySelector('.cart-drawer__recs-title');
          if (title) title.textContent = 'Frequently Bought Together';
          drawer.dataset.melRecsFinal = '1';
          markRecommendationsReady(drawer);
        }
        return;
      }

      const seed = slot.getAttribute('data-seed-product-id');
      const baseUrl = slot.getAttribute('data-section-url');
      if (!seed || !baseUrl) {
        markRecommendationsReady(drawer);
        return;
      }

      let cartIds = [];
      try { cartIds = JSON.parse(slot.getAttribute('data-cart-product-ids') || '[]'); } catch (error) { cartIds = []; }

      const fetchIntent = async (intent) => {
        const response = await fetch(`${baseUrl}&intent=${intent}&product_id=${encodeURIComponent(seed)}`, { credentials: 'same-origin' });
        return buildRecommendationHtml(await response.text(), cartIds);
      };

      try {
        const html = (await fetchIntent('complementary')) || (await fetchIntent('related'));
        if (html) {
          slot.innerHTML = html;
          drawer.dataset.melRecsFinal = '1';
        }
      } catch (error) {
        // Keep the drawer usable if recommendation refresh fails.
      } finally {
        markRecommendationsReady(drawer);
      }
    };

    CartDrawer.prototype.open = function mellowbyOpen(triggeredBy) {
      const openedFromHeaderBag = triggeredBy && (triggeredBy.id === 'cart-icon-bubble' || triggeredBy.closest?.('#cart-icon-bubble'));
      if (openedFromHeaderBag) {
        this.classList.remove('mel-added-confirmation');
        setBagHeading(this);
      }
      originalOpen.call(this, triggeredBy);
    };

    CartDrawer.prototype.renderContents = function mellowbyRenderContents(parsedState) {
      delete this.dataset.melRecsFinal;
      this.classList.remove('mel-recs-ready');
      this.classList.add('mel-recs-loading');
      originalRenderContents.call(this, parsedState);
      this.classList.add('mel-added-confirmation');
      setTimeout(() => { setAddedHeading(this); refreshRecommendationCarousel(this); }, 80);
      setTimeout(() => { setAddedHeading(this); refreshRecommendationCarousel(this); }, 800);
      setTimeout(() => { setAddedHeading(this); markRecommendationsReady(this); }, 1800);
    };

    document.addEventListener('DOMContentLoaded', () => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) setBagHeading(drawer);
    });
  };

  if (customElements.get('cart-drawer')) {
    patch(customElements.get('cart-drawer'));
  } else {
    customElements.whenDefined('cart-drawer').then(() => patch(customElements.get('cart-drawer')));
  }
})();
